<!-- 由 suu 创建于 2021-07-08 星期四 -->
<template>
  <div>
    <div class="food-rank" v-if="info">
      <div class="fr-top">
        <div class="t-title">
          {{ info.info.title }}
          <span><i class="iconfont icon-zhishi"></i>小知识</span>
        </div>
        <div class="t-tips">{{ info.info.describe }}</div>
      </div>
      <div class="fr-list">
        <div class="l-item" v-for="(item, index) in info.list" :key="item.id">
          <div class="i-no" :class="'i-no-' + index">{{ index + 1 }}</div>
          <div class="i-right">
            <img class="i-img" :src="item.image" alt="" />
            <div class="i-desc">
              <div class="d-top">{{ item.name }}</div>
              <div class="d-bot">
                {{ getValue(item.ordervalue) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>

<script>
export default {
  name: 'calorie-query-rank',

  components: {},

  props: {},

  data() {
    return {
      info: null,
      loaded: false
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getDetailInfo()
  },

  mounted() {},

  destroyed() {},

  methods: {
    getValue(value) {
      return this.info.info.tips.replace('<value>', value)
    },
    // https://btwx.gymcity.com.cn
    // 获取排行榜
    getDetailInfo() {
      //this.$Indicator.open('获取数据中……')
      this.$http
        .getApp('facility/calorie/FoodRank', {
          rankid: this.$route.query.id
        })
        .then((rs) => {
          if (rs.data.code === 200) {
            this.info = rs.data.data
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.data.msg
            })
          }
        })
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.food-rank {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 10vw;
  background-color: #fff;
  text-align: left;
  .fr-top {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 4.3vw;
    .t-title {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-size: 4vw;
      font-weight: 600;
      color: #000000;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2.4vw;
        font-weight: 600;
        color: #fff;
        margin-left: 2.7vw;
        width: 13.6vw;
        height: 3.7vw;
        background-color: #49ceba;
        border-radius: 0.8vw;
        i {
          font-size: 2.1vw;
        }
      }
    }
    .t-tips {
      width: 100%;
      box-sizing: border-box;
      font-size: 3.2vw;
      line-height: 5.3vw;
      color: rgba(0, 0, 0, 0.5);
      margin-top: 1.1vw;
    }
  }
  .fr-list {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-top: 2.7vw solid #f7f7f7;
    .l-item {
      width: 100%;
      box-sizing: border-box;
      padding-left: 5.3vw;
      display: flex;
      align-items: center;
      .i-no {
        width: 100%;
        box-sizing: border-box;
        font-size: 3.2vw;
        color: #000;
        width: 4.8vw;
        text-align: center;
      }
      .i-no-0,
      .i-no-1,
      .i-no-2 {
        width: 4.8vw;
        height: 4.8vw;
        background-image: linear-gradient(180deg, #ffd176 0%, #fbb336 100%);
        border-radius: 0.8vw;
        font-size: 3.2vw;
        font-weight: 600;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .i-no-1 {
        background-image: linear-gradient(180deg, #c7d3e0 0%, #869db6 100%);
      }
      .i-no-2 {
        background-image: linear-gradient(180deg, #e0cdc7 0%, #b28d80 100%);
      }
      .i-right {
        flex: 1;
        height: 100%;
        box-sizing: border-box;
        margin-left: 5.9vw;
        display: flex;
        align-items: center;
        padding: 5.3vw 5.9vw;
        padding-left: 0;
        border-bottom: 0.3vw solid #f7f7f7;
        .i-img {
          width: 17.1vw;
          height: 12.8vw;
          background-color: #d8d8d8;
          border-radius: 1.1vw;
          object-fit: cover;
        }
        .i-desc {
          margin-left: 4.3vw;
          .d-top {
            font-size: 4vw;
            font-weight: 600;
            color: #000;
          }
          .d-bot {
            display: flex;
            align-items: center;
            font-size: 3.2vw;
            color: #000;
            margin-top: 2.1vw;
            span {
              color: #dc0050;
            }
          }
        }
      }
    }
    .l-item:last-child .i-right {
      border-bottom: none;
    }
  }
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
